import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate, Link, NavLink } from "react-router-dom";
import { AuthContext } from "../../auth/auth";
import classes from "./Header.module.css";
export default function Header() {
  const navigate = useNavigate();
  const { user, logOut, loading } = React.useContext(AuthContext);
  // Handle user logout
  const handleSignOut = () => {
    logOut()
      .then(() => {
        console.log("User logged out successfully");
        // navigate("/login");
      })
      .catch((error) => console.error(error));
  };

  const navLinks = (
    <>
      {!user && (
        <div className={classes.link}>
          <p>
            <NavLink to="/login">Login</NavLink>
          </p>
          {/* <p>
            <NavLink to="/sign-up">Sign-Up</NavLink>
          </p> */}
        </div>
      )}
    </>
  );
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            AI Avatar Generation
          </Typography>
          {loading ? (
            <span className="loading loading-dots loading-lg flex item-center mx-auto"></span>
          ) : (
            navLinks
          )}
          {user && (
            <Button color="inherit" onClick={handleSignOut}>
              Logout
            </Button>
          )}
          <Button color="inherit" onClick={() => navigate("/history")}>
            History
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
